module.exports = __webpack_public_path__ + "img/logo.83298185.png";